import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import {isEmpty} from 'lodash'
import  {useSelector} from 'react-redux'
import IntlMessages from 'util/IntlMessages';
const useStyles = makeStyles((theme) => ({
    root: {
      '& .MuiTextField-root': {
        margin: theme.spacing(0),
      //   width: '28ch',
      },
    },
  }));

export default function InputComponent(props) {
    const classes = useStyles();
    const [contactPerson, setContactPerson] = React.useState(props.Ansvarig);
    const UserRole = useSelector(state => state.auth.authUser.user_role)
    const OfficeId = useSelector(state => state.auth.authUser.user_OfficeId)
    const MyOfficeType = useSelector(state => state.accountsData.MyOfficeType)

    React.useEffect(()=>{
        setContactPerson(props.Ansvarig)
    })
    console.log(UserRole,"UserRole")
    console.log(OfficeId,"UserRole")
    console.log(MyOfficeType,"UserRole")
    console.log(props.Userlista,"UserRole")
    return (
        <form className={classes.root} noValidate autoComplete="off">
      <div>
        <TextField
          variant="outlined"
          fullWidth
          label={<IntlMessages id="appKontoModule.Owner"/>}
          size="small"
          name="Ansvarig"
          select
          value={contactPerson}
          SelectProps={{
            native: true,
          }}
          InputLabelProps={{
            shrink: true,
          }}
          onChange={props.selectedthisOwner}
        >
           {
          isEmpty(props.Userlista)?"":
          parseInt(UserRole) > 1?
          parseInt(OfficeId) > 0?
          parseInt(MyOfficeType) ===2?
          props.Userlista.filter(item=>{return item.OfficeId ===OfficeId }).map((option) => (
            <option key={option.id} value={option.id}>
              {option.FirstName} {option.LastName}
            </option>
          ))
          :   
          props.Userlista.map((option) => (
            <option key={option.id} value={option.id}>
              {option.FirstName} {option.LastName}
            </option>
          ))
          :   
          props.Userlista.map((option) => (
            <option key={option.id} value={option.id}>
              {option.FirstName} {option.LastName}
            </option>
          ))
          :
          props.Userlista.map((option) => (
            <option key={option.id} value={option.id}>
              {option.FirstName} {option.LastName}
            </option>
          ))}
          {/*props.Userlista.filter(item=>{return !isEmpty(item.UserEmail)}).map((option) => (
            <option key={option.id} value={option.id}>
              {option.FirstName} {option.LastName}
            </option>
          ))*/}
        </TextField>
      </div>
    </form>
    );
}